import { useState, useMemo, useEffect } from "react";
import { Plus, Eye, X, Edit, Trash2, RefreshCcw } from "lucide-react";
import AddWorkflowAll from "./AddWorkflowAll";
import { getPriorityColor, getStatusColor } from "../../utils/colors";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import taskApi from "../../api/taskApi";
import AddTasksAll from "../task/AddTasksAll";
import WorkflowDocumentsViewer from "../Upload/WorkflowDocumentsViewer";
import workflowApi from "../../api/workflowApi";
import { confirmSubmit } from "../../utils/confirmSubmit";
import { useNavigate } from "react-router-dom";

const formatText = (text = "") =>
    text
        .toLowerCase()
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

const WorkflowTasksTabAll = ({
  onRefreshAccounts,
  heading,
  allTasks,
  type,
  errors,
  accountId,
  workflowDropdown,
  formData, 
  setFormData,
  handleSubmit,
  isLoader,
  showCreateTask, 
  setShowCreateTask,
  handleDeleteTask,
  workflowId,
  setWorkflowId,
  fetchWorkflows,
  clients,
  workflowTemplates
}) => {

  const token = useSelector((state) => state.auth.access_token);
  const currentUserId = useSelector((state) => state.auth.userdetails.id);
  const user = useSelector((state) => state.auth.userdetails.fullName);
  const [viewTask, setViewTask] = useState(null);
  const [isLoader2, setIsLoader2] = useState(null);
  const [editTask, setEditTask] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [comments, setComments] = useState([{ content: "" }]);
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    category: "all",
    assignee: "all",
    tempalate: "all",
    status: "all",
  });

  const fetchWorkflowsById = async() =>{
    try {
       await workflowApi.WorkflowByAccountId(accountId, token);
      
    } catch (error) {
      console.log("error : ",error)
    }
  }
  useEffect(()=>{
    fetchWorkflowsById();
  },[])
  const filteredTasks = useMemo(() => {
    if (!allTasks) return [];

    let tasks = [...allTasks];

    // Filter
    if (filters.assignee !== "all") {
      tasks = tasks.filter(
        (task) => task?.assignedTo?.fullName === filters.assignee
      );
    }
    if (filters.category !== "all") {
      tasks = tasks.filter((task) => task.category === filters.category);
    }
    if (filters.tempalate !== "all") {
      tasks = tasks.filter((task) => task.tempalate === filters.tempalate);
    }
    if (filters.status !== "all") {
      tasks = tasks.filter((task) => task.status === filters.status);
    }

    tasks.sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate));

    return tasks;
  }, [allTasks, filters]);

  const assignees = [
    ...new Set(
      allTasks
        ?.map((t) => t?.assignedTo?.fullName)
        .filter(Boolean)
    ),
  ];
  const tempalates = [
    ...new Set(
      allTasks
        ?.map((t) => t?.tempalate)
        .filter(Boolean)
    ),
  ];
  const categoryes = [
    ...new Set(
      allTasks?.map((t) => t?.category).filter(Boolean)
    ),
  ];
  const statuses = [
    ...new Set(
      allTasks?.map((t) => t?.status).filter(Boolean)
    ),
  ];

  const formatDate = (dateString) => {
        if (!dateString) return "Not set";
        return new Date(dateString).toLocaleDateString();
    };

    const deleteTasksWorkflow = async (taskId)=> {
        const isConfirmed = await confirmSubmit({
                  title: "Confirm task delete",
                  text: "Are you sure you want to delete this task?",
                  confirmText: "Submit",
                });
              if (!isConfirmed) return;
          try {
              await taskApi.deleteTask(taskId, token);
              toast.success("Task deleted successfully");
              fetchWorkflows();
              onRefreshAccounts();
              setViewTask((prev) => ({
                ...prev,
                tasks: prev.tasks.filter((task) => task.id !== taskId),
              }));
          } catch (error) {
              console.error("Error deleting task:", error);
              toast.error("Failed to delete task");
          }
      
    }
    const [errors2, setErrors2] = useState({});
        const safeTrim = (value) => (value || "").trim();
      
        const validateForm = () => {
              const newErrors = {};
      
              if (!safeTrim(editTask.title))
                  newErrors.title = "Title is required";
      
              if (!safeTrim(editTask.assignedTo))
                  newErrors.assignedTo = "Assigned To is required";
      
              if (!editTask.account)
                  newErrors.account = "Account is required";
              if (!editTask.status)
                  newErrors.status = "Status is required";
              if (!editTask.priority)
                  newErrors.priority = "Priority is required";
              if (!editTask.startDate)
                  newErrors.startDate = "Start Date is required";
              if (!editTask.dueDate)
                  newErrors.dueDate = "Due Date is required";
              if (!editTask.description)
                  newErrors.description = "Description is required";
      
              setErrors2(newErrors);
              return Object.keys(newErrors).length === 0;
              };
      
    const handleSubmitTaskEdit = async ()=> {
      if (!validateForm()) {
                toast.error("Please fill all required fields correctly.");
                setIsLoader2(false);
                return;
            }
        const isConfirmed = await confirmSubmit({
                  title: "Edit task",
                  text: "Are you sure you want to edit this task?",
                  confirmText: "Submit",
                  icon: "error",
                });
              if (!isConfirmed) return;
        
            if (!isConfirmed) return;
          try {
            setIsLoader2(true);
            const today = new Date();
            const tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 1);

            const now = new Date().toISOString();
            const formattedComments = comments.filter(c => c?.content?.trim() !== "");
            const payload = {
              ...editTask,
              assignedTo: { id: editTask.assignedTo },
              account: { id: editTask.account },
              createdBy: { id: currentUserId, fullName: user },
              updatedBy: { id: currentUserId, fullName: user },
              updatedAt: now,
              attachments: attachments,
              comments: formattedComments,
            };
             const res = await taskApi.updateTask(taskId, payload, token);
             if (res?.success && res?.data) {
                toast.success("Task edit successfully");
                fetchWorkflows();
                onRefreshAccounts();
                setViewTask((prev) => ({
                  ...prev,
                  tasks: prev.tasks.map((task) =>
                    task.id === taskId ? res?.data : task
                  ),
                }));
                setTaskId(null); 
                setEditTask(null);
                setIsLoader2(false);
             }
          } catch (error) {
            setIsLoader2(false);
              console.error("❌ Error edit task:", error);
              // toast.error("Failed to edit task");
          }
    }

    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: "asc", // asc | desc
      });
    
      const handleSort = (key) => {
        setSortConfig((prev) => {
          if (prev.key === key) {
            return {
              key,
              direction: prev.direction === "asc" ? "desc" : "asc",
            };
          }
          return { key, direction: "asc" };
        });
      };

    const getValueByPath = (obj, path) =>
      path.split(".").reduce((acc, key) => acc?.[key], obj);
    const sortedTasks = useMemo(() => {
          if (!sortConfig.key) return filteredTasks;
    
          return [...filteredTasks].sort((a, b) => {
            const aVal = getValueByPath(a, sortConfig.key);
            const bVal = getValueByPath(b, sortConfig.key);
    
            if (!aVal) return 1;
            if (!bVal) return -1;
    
            if (typeof aVal === "string") {
              return sortConfig.direction === "asc"
                ? aVal.localeCompare(bVal)
                : bVal.localeCompare(aVal);
            }
    
            return sortConfig.direction === "asc"
              ? aVal > bVal ? 1 : -1
              : aVal < bVal ? 1 : -1;
          });
        }, [filteredTasks, sortConfig]);
        const SortIcon = ({ column }) => {
        const isActive = sortConfig.key === column;

        return (
          <span className="inline-flex flex-col ml-1 text-[9px] leading-none">
            <span
              className={
                isActive && sortConfig.direction === "asc"
                  ? "text-gray-900"
                  : "text-gray-300"
              }
            >
              ▲
            </span>
            <span
              className={
                isActive && sortConfig.direction === "desc"
                  ? "text-gray-900"
                  : "text-gray-300"
              }
            >
              ▼
            </span>
          </span>
        );
      };
    

  return (
    <div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-2 py-2">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <h3 className="text-lg font-bold text-slate-700">{heading}</h3>
          <button
            // onClick={() => setShowCreateTask(true)}
            onClick={() => navigate('/create/workflows')}
            className="bg-primary text-white px-3 py-1 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2 w-full sm:w-auto"
          >
            <Plus className="h-4 w-4" />
            <span>Add Workflow</span>
          </button>
        </div>

        {allTasks?.length !== 0 ?
        <div className="grid grid-cols-1 sm:grid-cols-5 gap-3 mt-1">
          {assignees.length !==0 ?
          <select
            className="border rounded-lg px-3 py-1 text-sm"
            value={filters.assignee}
            onChange={(e) =>
              setFilters({ ...filters, assignee: e.target.value })
            }
          >
            <option value="all">All Assignees</option>
            {assignees.map((name, idx) => (
              <option key={idx} value={name}>
                {formatText(name)}
              </option>
            ))}
          </select>:<></>}

          <select
            className="border rounded-lg px-3 py-1 text-sm"
            value={filters.category}
            onChange={(e) =>
              setFilters({ ...filters, category: e.target.value })
            }
          >
            <option value="all">All Category</option>
            {categoryes.map((p, idx) => (
              <option key={idx} value={p}>
                {formatText(p)}
              </option>
            ))}
          </select>

          {tempalates.length !==0 ?
          <select
            className="border rounded-lg px-3 py-1 text-sm"
            value={filters.tempalate}
            onChange={(e) =>
              setFilters({ ...filters, tempalate: e.target.value })
            }
          >
            <option value="all">All Templates</option>
            {tempalates.map((name, idx) => (
              <option key={idx} value={name}>
                {formatText(name)}
              </option>
            ))}
          </select>:<></>}

          <select
            className="border rounded-lg px-3 py-1 text-sm"
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            <option value="all">All Status</option>
            {statuses.map((s, idx) => (
              <option key={idx} value={s}>
                {formatText(s)}
              </option>
            ))}
          </select>
          <div className="flex items-end justify-end">
            <button
                type="button"
                onClick={() => setFilters({
                  category: "all",
                  assignee: "all",
                  tempalate: "all",
                  status: "all",
                })}
                className="bg-primary py-1 px-2 rounded-md text-sm font-medium text-white hover:bg-primary [&:active_span]:animate-spin-once"
            >
               <span className="inline-block">
                                   <RefreshCcw size={18} />
                                 </span>
            </button>
          </div>
        </div>:<></>}
        <div className="py-2 mt-1">
          {filteredTasks?.length !== 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-2 py-1 text-left text-slate-700">#</th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("name")}><span className="flex flex-row items-center gap-1">Title <SortIcon column="name" /></span></th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("category")}><span className="flex flex-row items-center gap-1">Category <SortIcon column="category" /></span></th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("tempalate")}><span className="flex flex-row items-center gap-1">Tempalate <SortIcon column="tempalate" /></span></th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("assignedTo.fullName")}><span className="flex flex-row items-center gap-1">AssignedTo <SortIcon column="assignedTo.fullName" /></span></th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("tasks.length")}><span className="flex flex-row items-center gap-1">Tasks <SortIcon column="tasks.length" /></span></th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("status")}><span className="flex flex-row items-center gap-1">Status <SortIcon column="status" /></span></th>
                    <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("dueDate")}><span className="flex flex-row items-center gap-1">Due Date <SortIcon column="dueDate" /></span></th>
                    <th className="px-2 py-1 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {sortedTasks.map((task, index) => (
                    <tr key={task?.id} className="hover:bg-gray-50">
                      <td className="px-2 py-1">{index + 1}</td>
                      <td className="px-2 py-1 font-medium">{task.name}</td>
                      <td className="px-2 py-1">{formatText(task?.category)}</td>
                      <td className="px-2 py-1">{formatText(task?.template)}</td>
                      <td className="px-2 py-1">{formatText(task?.assignedToName)}</td>
                      <td className="px-2 py-1">
                          {task.tasks?.length || 0}
                      </td>
                      <td className="px-2 py-1">
                        <span
                          className={`px-2 py-0.5 text-xs rounded-full ${getStatusColor(
                            task.status
                          )}`}
                        >
                          {formatText(task.status)}
                        </span>
                      </td>
                      <td className="px-2 py-1">{task.dueDate}</td>
                      <td className="px-2 py-1 text-center">
                        <div className="flex flex-row items-center justify-center gap-1">
                          <button
                            onClick={() => setViewTask(task)}
                            className="text-blue-600 hover:text-blue-900"
                          >
                            <Eye size={14} />
                          </button>
                          
                          <button
                            onClick={() => {setWorkflowId(task?.id); setFormData({
                                name: task.name || "",
                                description: task.description || "",
                                category: task.category || "",
                                status: task.status || "",
                                account: task?.accountId || "",
                                template: task.template || "",
                                assignedTo: task?.assignedToId || "",
                                createdBy: task.createdBy || "",
                                startDate: task.startDate || "",
                                dueDate: task.dueDate || "",
                              });}}
                            className="text-blue-600 hover:text-blue-900"
                          >
                            <Edit size={14} />
                          </button>
                          
                          <button
                            onClick={() => handleDeleteTask(task?.id)}
                            className="p-1 text-red-600 hover:text-red-800"
                            title="Delete"
                          >
                            <Trash2 size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
              <div className="text-gray-400 mb-1">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
              </div>
              <h4 className="text-lg font-medium text-gray-900 mb-1">No Workflows</h4>
              <p className="text-gray-600 mb-4">
                No workflows found. Create your first workflow to get started.
              </p>
            </div>
          )}
        </div>
      </div>


      {showCreateTask && 
      <div onClick={() => setShowCreateTask(false)} className="fixed -top-6 inset-0 bg-black/40 flex items-center justify-center">
        <AddWorkflowAll
          type={type}
          clients={clients}
          workflowDropdown={workflowDropdown}
          onRefreshAccounts={onRefreshAccounts}
          onClose={() => setShowCreateTask(false)}
          setShowCreateTask={setShowCreateTask}
          workflowTemplates={workflowTemplates}
          formData={formData}
          setFormData={setFormData}
          handleSubmit={handleSubmit}
          isLoader={isLoader}
          errors={errors}
        />
      </div>}

      {workflowId && 
      <div onClick={() => setWorkflowId(null)} className="fixed -top-6 inset-0 bg-black/40 flex items-center justify-center">
        <AddWorkflowAll
          type={type}
          clients={clients}
          workflowDropdown={workflowDropdown}
          onRefreshAccounts={onRefreshAccounts}
          onClose={() => setWorkflowId(null)}
          setShowCreateTask={setWorkflowId}
          workflowTemplates={workflowTemplates}
          formData={formData}
          setFormData={setFormData}
          handleSubmit={handleSubmit}
          isLoader={isLoader}
          workflowId={workflowId}
          accountId={accountId}
          errors={errors}
        />
      </div>}

      {/* {viewTask && (
        <div className="fixed inset-0 -top-6 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full">
            <div className="flex justify-between items-center px-2 py-1 border-b">
              <div className="text-lg font-semibold text-gray-900">
                Task Details
              </div>
              <button
                onClick={() => setViewTask(null)}
                className="p-1 rounded-md bg-red-50 text-red-700 hover:bg-red-100 transition"
              >
                <X size={20} />
              </button>
            </div>

            <div className="px-6 py-1 text-sm text-gray-700">


              <div className="grid grid-cols-1 md:grid-cols-4 mb-0">
                <div className="mb-0">
                  <div className="text-xs text-gray-400">Title</div>
                  <div className="font-semibold text-gray-900">
                    {viewTask.title}
                  </div>
                </div>
                {viewTask?.assignedTo?.fullName ?
                <div>
                  <div className="text-xs text-gray-400">Assignee</div>
                  <div className="font-medium">
                    {viewTask?.assignedTo?.fullName || "Unassigned"}
                  </div>
                </div> :
                <div>
                  <div className="text-xs text-gray-400">Workflow</div>
                  <div className="font-medium">
                    {formatText(viewTask?.workflowName)}
                  </div>
                </div>}

                <div>
                  <div className="text-xs text-gray-400">Due Date</div>
                  <div className="font-medium">
                    {viewTask.dueDate || "N/A"}
                  </div>
                </div>
                <div className="flex flex-row items-center mb-0">
                  <div>
                    <div className="text-xs text-gray-400">Priority</div>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium mr-2
                      ${viewTask.priority === "High"
                        ? "bg-red-100 text-red-600"
                        : viewTask.priority === "Medium"
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-green-100 text-green-600"}
                    `}>
                      {formatText(viewTask.priority)}
                    </span>
                  </div>

                  <div>
                    <div className="text-xs text-gray-400">Status</div>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium
                      ${viewTask.status === "Completed"
                        ? "bg-green-100 text-green-600"
                        : viewTask.status === "In Progress"
                        ? "bg-blue-100 text-blue-600"
                        : "bg-gray-100 text-gray-600"}
                    `}>
                      {formatText(viewTask.status)}
                    </span>
                  </div>
                </div>
              </div>

              {viewTask.description ?
              <div>
                <p className="text-xs text-gray-400 mb-0">Description</p>
                <p className="bg-gray-50 rounded-lg px-2 py-1 text-gray-700">
                  {viewTask.description || "No description provided."}
                </p>
              </div>:<></>}
            </div>
          </div>
        </div>
      )} */}
      {viewTask && (
      <div
        onClick={() => setViewTask(null)}
        className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center"
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-white rounded-lg shadow-2xl max-w-[100vw] w-full max-h-[100vh] overflow-x-auto"
        >
          {/* Header */}
          <div className="flex justify-between items-center px-2 py-2 border-b">
            <div className="text-lg font-semibold text-gray-900">
              Workflow Details
            </div>
            <button
              onClick={() => setViewTask(null)}
              className="p-1 rounded-md bg-red-50 text-red-700 hover:bg-red-100"
            >
              <X size={20} />
            </button>
          </div>

          {/* Body */}
          <div className="p-2 text-sm space-y-1">
            {/* Title */}
            <div>
              <div className="text-lg font-semibold text-gray-900">
                {viewTask?.name}
              </div>
              <div className="text-xs text-gray-400">Workflow Overview</div>
            </div>

            {/* Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-1">
              <InfoCard
                label="Assignee"
                value={viewTask?.createdBy?.fullName || "N/A"}
              />
              <InfoCard
                label="Workflow"
                value={formatText(viewTask?.template)}
              />
              <InfoCard
                label="Start Date"
                value={viewTask?.startDate || "N/A"}
              />
              <InfoCard
                label="Due Date"
                value={viewTask?.dueDate || "N/A"}
              />
              <StatusBadge status={viewTask?.status} />
            </div>

            {/* Description */}
            {viewTask?.description && (
              <div className="border-t pt-1">
                <p className="text-xs text-gray-400 mb-1">Description</p>
                <div className="bg-gray-50 rounded-lg px-3 py-2 text-gray-700">
                  {viewTask.description}
                </div>
              </div>
            )}

            {/* <WorkflowDocumentsViewer workflowId={viewTask.id} /> */}

          </div>
          <div className="p-2 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {viewTask?.tasks?.length > 0 ? (
                viewTask?.tasks?.map((task) => (
                    <div key={task.id} className=" border border-gray-200 rounded-lg p-3 shadow-sm">
                        <div className="flex justify-between items-start">
                            <div className="flex-grow">
                                <div className="flex items-center gap-2 mb-0">
                                    <div className="font-semibold text-base text-gray-800">{task.title}</div>
                                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(task.priority)}`}>
                                        {task.priority}
                                    </span>
                                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(task.status)}`}>
                                        {task.status.replace('_', ' ')}
                                    </span>
                                </div>
                                {task.description && (
                                    <p className="text-gray-600 text-sm mb-0">{task.description}</p>
                                )}
                                <div className="flex flex-wrap gap-4 text-xs text-gray-500">
                                    <span className="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                        Start: {formatDate(task.startDate)}
                                    </span>
                                    <span className="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        Due: {formatDate(task.dueDate)}
                                    </span>
                                </div>
                            </div>
                            <div className="space-x-1">
                              <button
                                  // onClick={() => {setEditTask(task); setTaskId(task?.id)}}
                                  onClick={() => {setTaskId(task?.id); 
                                      setEditTask({
                                        title: task?.title || "",
                                        description: task?.description || "",
                                        startDate: task?.startDate || "",
                                        dueDate: task?.dueDate || "",
                                        priority: task?.priority || "",
                                        status: task?.status || "TODO",
                                        account: task?.account?.id || "",
                                        workflowId: task?.workflowName ? workflowDropdown?.find( (item) => item.label === task.workflowName )?.value : "",
                                        assignedTo: task?.assignedTo?.id || "",
                                      });
                                    setAttachments(task?.attachments);
                                    setComments(task?.comments.length !==0 ? task?.comments : [{ content: "" }]);
                                  }}
                                  className="text-blue-500 hover:text-blue-700"
                                  aria-label="Delete task"
                                  title="Delete task"
                              >
                                  <Edit size={16}/>
                              </button>
                              <button
                                  onClick={() => deleteTasksWorkflow(task.id)}
                                  className="text-red-500 hover:text-red-700"
                                  aria-label="Delete task"
                                  title="Delete task"
                              >
                                  <Trash2 size={16}/>
                              </button>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <p className="text-gray-500 text-center py-4">No tasks available.</p>
            )}
          </div>
        </div>
      </div>)}

      {taskId && 
      <div onClick={() => {setTaskId(null); setEditTask(null)}} className="fixed z-50 -top-6 inset-0 bg-black/40 flex items-center justify-center">
        <AddTasksAll
          type={"task"}
          onClose={() => setTaskId(null)}
          setShowCreateTask={setTaskId}
          workflowDropdown={workflowDropdown}
          onRefreshAccounts={onRefreshAccounts}
          formData={editTask}
          setFormData={setEditTask}
          handleSubmit={handleSubmitTaskEdit}
          isLoader={isLoader2}
          taskId={taskId}
          attachments={attachments}
          setAttachments={setAttachments}
          comments={comments}
          setComments={setComments}
          errors={errors2}
        />
      </div>}
    </div>
  );
};

export default WorkflowTasksTabAll;


const InfoCard = ({ label, value }) => (
  <div className="bg-gray-50 rounded-lg px-2 py-2">
    <div className="text-xs text-gray-400">{label}</div>
    <div className="font-medium text-gray-800">{value}</div>
  </div>
);

const StatusBadge = ({ status }) => (
  <div className="bg-gray-50 rounded-lg p-2">
    <div className="text-xs text-gray-400">Status</div>
    <span
      className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold mt-1
        ${
          status === "TODO"
            ? "bg-gray-200 text-gray-700"
            : status === "IN_PROGRESS"
            ? "bg-blue-100 text-blue-600"
            : "bg-green-100 text-green-600"
        }
      `}
    >
      {formatText(status)}
    </span>
  </div>
);

